import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ErisLoginService} from '../eris-login.service';
import {AccountService} from '../../account.service';

@Component({
  selector: 'lib-auth-callback',
  templateUrl: './auth-callback.component.html',
  styles: []
})
export class AuthCallbackComponent implements OnInit {

  constructor(private authService: ErisLoginService, private accountService: AccountService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let to = params['to'];
      if (to === 'signin') {
        this.authService.completeAuthentication()
          .then(token => {
            // Drop stale menu/user cache from a previous session or a failed empty menus response.
            this.accountService.removeData();
            this.router.navigateByUrl('/');
          })
          .catch(err => {
            console.error('OIDC sign-in callback failed', err);
            this.router.navigate(['/login'], { queryParams: { reason: 'callback-failed' } });
          });
      } else if (to === 'signout') {
        // Landing here after the STS end-session redirect: finish the local sign-out and show the
        // sign-in page without immediately bouncing back to the STS.
        this.authService.completeSignout().then(() => {
          this.accountService.removeData();
          this.router.navigate(['/login'], { queryParams: { reason: 'signed-out' } });
        });
      }
    });
  }

}
